import * as React from 'react';
import { Component } from 'react';
import { computed } from 'mobx';
import { observer } from 'mobx-react';
import styled, { withTheme } from 'styled-components';
import { propStyles } from '@kurtosys/ksys-portal-components/build/utils/propStyles';
import get from 'lodash/get';
import Translate from './Translate';
import DocumentDropDown from './DocumentDropDown';
import Icon from './Icon';
import { replacePropertyPlaceholders } from '../utils/replacePlaceholders';

const KeyDocumentsWrapper = styled<any, any>('div')`
    ${propStyles};
`;

KeyDocumentsWrapper.defaultProps = {
    margin: '0 0 24px 0',
};

const KeyDocumentsHeading = styled<any, any>('h2')`
    ${propStyles};
`;

KeyDocumentsHeading.defaultProps = {
    color: 'body',
    fontFamily: 'heading',
    fontWeight: 'bold',
    fontSize: 'md',
};

const KeyDocumentsList = styled<any, any>('ul')`
    ${propStyles};
`;

KeyDocumentsList.defaultProps = {
    listStyle: 'none',
    marginY: 'sm',
};

const KeyDocumentsListItem = styled<any, any>('li')`
    ${propStyles};
`;

KeyDocumentsListItem.defaultProps = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingY: 'sm',
    borderWidth: '1px',
    borderStyle: 'none none solid none',
    borderColor: 'gray300',
};

const KeyDocumentsLink = styled<any, any>('a')`
    ${propStyles};
`;

KeyDocumentsLink.defaultProps = {
    display: 'block',
    marginY: 'md',
    color: 'link',
    fontFamily: 'heading',
    fontWeight: 'bold',
    fontSize: 'xs',
    hover: {
        color: 'linkHover',
    },
};

@observer
class KeyDocuments extends Component<any, any> {
    @computed
    get documentsLinkUrl() {
        const { linkProperty } = this.props.keyDocumentsConfig;
        const linkValue = get(
            this.props.shareClass,
            `properties_pub.${linkProperty}.value`,
            ''
        );
        const parsedLink = replacePropertyPlaceholders(
            this.props.shareClass.properties_pub,
            linkValue
        );
        return parsedLink;
    }

    @computed
    get documentsLinkLabel() {
        const { linkLabel } = this.props.keyDocumentsConfig;
        return linkLabel;
    }

    render() {
        const {
            theme,
            keyDocumentsConfig,
            keyDocuments,
            showHeading,
        } = this.props;
        const { documentsLinkUrl, documentsLinkLabel } = this;
        // explicit check to deal with undefined and default to show
        const showDocumentIcon = keyDocumentsConfig.showIcon !== false;
        return (
            <KeyDocumentsWrapper {...theme.KeyDocumentsWrapper}>
                {showHeading && (
                    <KeyDocumentsHeading {...theme.KeyDocumentsHeading}>
                        <Translate>{keyDocumentsConfig.label}</Translate>
                    </KeyDocumentsHeading>
                )}
                <KeyDocumentsList {...theme.KeyDocumentsList}>
                    {keyDocuments.map(d => (
                        <KeyDocumentsListItem
                            key={d.documentGroupName}
                            {...theme.KeyDocumentsListItem}
                        >
                            <Translate>{d.documentGroupName}</Translate>
                            <DocumentDropDown
                                documents={d.documents}
                                documentSelected={() => null}
                                toggleDownload={() => null}
                            >
                                {showDocumentIcon && (
                                    <Icon
                                        fileName="DocumentIcon"
                                        height="1.4em"
                                        width="1.4em"
                                    />
                                )}
                            </DocumentDropDown>
                        </KeyDocumentsListItem>
                    ))}
                </KeyDocumentsList>
                {documentsLinkUrl && documentsLinkLabel && (
                    <KeyDocumentsLink
                        href={documentsLinkUrl}
                        {...theme.KeyDocumentsLink}
                    >
                        <Translate>{documentsLinkLabel}</Translate>
                    </KeyDocumentsLink>
                )}
            </KeyDocumentsWrapper>
        );
    }
}

export default withTheme(KeyDocuments) as any;



// WEBPACK FOOTER //
// ./src/Components/KeyDocuments.tsx